import {
    AlertDialog,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
    AlertDialogTrigger,
  } from "@/Components/ui/alert-dialog";

interface ShowAlertDialogProps {
    title: string
    message: string
    children?: React.ReactNode
    dialogOpen?: boolean
    setDialogOpen?: (open: boolean) => void
}

function ShowAlert({title, message, children, dialogOpen, setDialogOpen} : ShowAlertDialogProps) {

    return (
    dialogOpen !== undefined && setDialogOpen !== undefined ? (
        <AlertDialog open={dialogOpen} onOpenChange={setDialogOpen}>
        {children && <AlertDialogTrigger className="rounded-md m-2 p-1 hover: cursor-pointer">{children}</AlertDialogTrigger>}
        <AlertDialogContent>
        <AlertDialogHeader>
            <AlertDialogTitle>{title}</AlertDialogTitle>
            <AlertDialogDescription>
            {message}
            </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
            <AlertDialogCancel>OK</AlertDialogCancel>
        </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>) 
    : 
    (
        <AlertDialog>
        {children && <AlertDialogTrigger className="rounded-md m-2 p-1 hover: cursor-pointer">{children}</AlertDialogTrigger>}
        <AlertDialogContent>
        <AlertDialogHeader>
            <AlertDialogTitle>{title}</AlertDialogTitle>
            <AlertDialogDescription>
            {message}
            </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
            <AlertDialogCancel>OK</AlertDialogCancel>
        </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>
    )
  );
}

export default ShowAlert;